//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {formatDate} from "../../../lib/date";

export default {
    name: "ticketDetail",
    data() {
        return {
            id: 0,
            coupon: {
                coupon: {}
            },
            salesClerk: {},
            shop: {},
            shopCoupon: {}
        }
    },
    filters: {
        formatDate(time, type) {
            var date = new Date(time);
            if (type == 1) {
                return formatDate(date, 'yyyy/MM/dd');
            }
            return formatDate(date, 'yyyy-MM-dd hh:mm');
        }
    },
    methods: {
        getShopCoupon() {
            abp.ajax.get('/api/services/app/Coupon/GetShopCouponById?id=' + this.id).then(res => {
                this.shopCoupon = {
                    userCoupon: {}
                };
                this.shopCoupon = res.data.result;
                this.coupon = this.shopCoupon.userCoupon;
                this.getShop(this.shopCoupon.shopId);
                // this.getMyCouponByCode()
                this.getSalesClerk(this.shopCoupon.salesClerkId)
            })
        },
        getShop(shopId) {
            abp.ajax.get('/api/services/app/Shop/GetShopById?id=' + shopId).then(res => {
                this.shop = {};
                this.shop = res.data.result;
            })
        },
        getMyCouponByCode(couponCode) {
            abp.ajax.get('/api/services/app/Coupon/GetMyCouponByCode?code=' + couponCode).then(res => {
                this.coupon = {};
                this.coupon = res.data.result;

            })
        },
        getSalesClerk(salesClerkId) {
            abp.ajax.get('/api/services/app/SalesClerk/GetSalesClerkById?id=' + salesClerkId).then(res => {
                this.salesClerk = {};
                this.salesClerk = res.data.result;
            })
        },
    },
    created() {
        this.id = parseInt(this.$route.params.id);
        if (this.id > 0) {
            this.getShopCoupon()
        }
    }
}
